import React, { useState } from "react";
import {
  Box,
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ExpandLess,
  ExpandMore,
  Dashboard,
  ContactMail,
  Business,
  DirectionsCar,
  Build,
  Assignment,
  People,
  MonetizationOn,
  //Store,
 // Inventory,
} from "@mui/icons-material";
import { LOGO_BASE64 } from "../components/constants";

const iconColor = "#2C6595";
const subtitleColor = "#1A3E5D";

const Sidebar = ({ onContentChange, mobileOpen, setMobileOpen }) => {
  const [openServices, setOpenServices] = useState(false);
  const [openManagement, setOpenManagement] = useState(false);
  //const [openInventory, setOpenInventory] = useState(false);
  const isMobileOrTablet = useMediaQuery("(max-width:1024px)");

  const handleServicesClick = () => setOpenServices(!openServices);
  const handleManagementClick = () => setOpenManagement(!openManagement);
  //const handleInventoryClick = () => setOpenInventory(!openInventory);
  const handleDrawerClose = () => setMobileOpen(false);

  const handleItemClick = (view) => {
    onContentChange(view);
    if (isMobileOrTablet) {
      handleDrawerClose();
    }
  };

  return (
    <>
      {isMobileOrTablet && (
        <IconButton
          onClick={() => setMobileOpen(!mobileOpen)}
          sx={{ position: "absolute", top: 16, left: 16, zIndex: 1300 }}
        >
          <MenuIcon sx={{ color: iconColor }} />
        </IconButton>
      )}

      <Drawer
        variant={isMobileOrTablet ? "temporary" : "permanent"}
        open={mobileOpen}
        onClose={handleDrawerClose}
        sx={{
          width: isMobileOrTablet ? "auto" : 240,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 240,
            boxSizing: "border-box",
            ...(isMobileOrTablet && {
              top: 0,
              height: "100vh",
            }),
          },
        }}
      >
        <Box p={2} textAlign="center">
          <img src={LOGO_BASE64} alt="Logo" style={{ width: "80%", marginBottom: "10px" }} />
        </Box>
        <Divider />
        <List sx={{ fontFamily: "Roboto, sans-serif", fontSize: "17px" }}>
          <ListItem button onClick={() => handleItemClick("dashboard")}>
            <ListItemIcon><Dashboard sx={{ color: iconColor }} /></ListItemIcon>
            <ListItemText primary="Dashboard" sx={{ fontSize: "17px" }} />
          </ListItem>

          {/* GESTIÓN */}
          <Typography variant="subtitle1" sx={{ pl: 2, mt: 2, fontWeight: "bold", fontFamily: "Roboto, sans-serif", color: subtitleColor, textTransform: "uppercase" }}>Gestión</Typography>
          <ListItem button onClick={handleManagementClick}>
            <ListItemIcon><People sx={{ color: iconColor }} /></ListItemIcon>
            <ListItemText primary="Administración" />
            {openManagement ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openManagement} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleItemClick("RegistroContactos")}>
                <ListItemIcon><ContactMail sx={{ color: iconColor }} /></ListItemIcon>
                <ListItemText primary="Registro de Contactos" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleItemClick("RegistroEmpresa")}>
                <ListItemIcon><Business sx={{ color: iconColor }} /></ListItemIcon>
                <ListItemText primary="Registro de Empresas" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleItemClick("RegistroRoles")}>
                <ListItemIcon><People sx={{ color: iconColor }} /></ListItemIcon>
                <ListItemText primary="Registro de Roles" />
              </ListItem>
            </List>
          </Collapse>

          {/* INVENTARIO */}
          {/* <Typography variant="subtitle1" sx={{ pl: 2, mt: 2, fontWeight: "bold", fontFamily: "Roboto, sans-serif", color: subtitleColor, textTransform: "uppercase" }}>Inventario</Typography>
          <ListItem button onClick={handleInventoryClick}>
            <ListItemIcon><Inventory sx={{ color: iconColor }} /></ListItemIcon>
            <ListItemText primary="Inventario" />
            {openInventory ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openInventory} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleItemClick("Catalogo")}>
                <ListItemIcon><Store sx={{ color: iconColor }} /></ListItemIcon>
                <ListItemText primary="Catálogo" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleItemClick("InventoryForm")}>
                <ListItemIcon><Assignment sx={{ color: iconColor }} /></ListItemIcon>
                <ListItemText primary="Registro de Pieza" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleItemClick("InventoryTable")}>
                <ListItemIcon><Build sx={{ color: iconColor }} /></ListItemIcon>
                <ListItemText primary="Tabla de Inventario" />
              </ListItem>
            </List>
          </Collapse> */}

          {/* SERVICIOS */}
          <Typography variant="subtitle1" sx={{ pl: 2, mt: 2, fontWeight: "bold", fontFamily: "Roboto, sans-serif", color: subtitleColor, textTransform: "uppercase" }}>Servicios</Typography>
          <ListItem button onClick={handleServicesClick}>
            <ListItemIcon><Build sx={{ color: iconColor }} /></ListItemIcon>
            <ListItemText primary="Servicios" />
            {openServices ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openServices} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
            <ListItem button sx={{ pl: 4 }} onClick={() => handleItemClick("SolicitudServicio")}>
                <ListItemIcon><Assignment sx={{ color: iconColor }} /></ListItemIcon>
                <ListItemText primary="Solicitud de Servicio" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleItemClick("SListaSolicitudes")}>
                <ListItemIcon><Assignment sx={{ color: iconColor }} /></ListItemIcon>
                <ListItemText primary="Lista Solicitud de Servicio" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleItemClick("RegistroServicios")}>
                <ListItemIcon><Assignment sx={{ color: iconColor }} /></ListItemIcon>
                <ListItemText primary="Registro de Servicios" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleItemClick("Cotizacion")}>
                <ListItemIcon><MonetizationOn sx={{ color: iconColor }} /></ListItemIcon>
                <ListItemText primary="Cotización" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleItemClick("RegistroUnidadTipoUnidad")}>
                <ListItemIcon><DirectionsCar sx={{ color: iconColor }} /></ListItemIcon>
                <ListItemText primary="Registro Unidad y Tipo de Unidad" />
              </ListItem>  
              <ListItem button sx={{ pl: 4 }} onClick={() => handleItemClick("TruckInspectionForm")}>
                <ListItemIcon><DirectionsCar sx={{ color: iconColor }} /></ListItemIcon>
                <ListItemText primary="Inspeccion de tractocamion" />
              </ListItem>  
            </List>
          </Collapse>
        </List>
      </Drawer>
    </>
  );
};

export default Sidebar;
